import { render, staticRenderFns } from "./kontak.vue?vue&type=template&id=cf8cbac8&"
import script from "./kontak.vue?vue&type=script&lang=js&"
export * from "./kontak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports